// ##################################################
// 0.0 - Number count up
// ##################################################

// How long you want the animation to take, in ms
const counterAnimationDuration = 2000;
// Calculate how long each ‘frame’ should last if we want to update
// the animation 60 times per second
const counterFrameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const counterTotalFrames = Math.round(counterAnimationDuration / counterFrameDuration);
// An ease-out function that slows the count as it progresses
const counterEaseOutQuad = (t) => t * (2 - t);

// The animation function, which takes an Element
const counterAnimateCountUp = (el) => {
  let frame = 0;
  const countTo = parseInt(el.innerHTML, 10);
  // Start the animation running 60 times per second
  const counter = setInterval(() => {
    frame += 1;
    // Calculate our progress as a value between 0 and 1
    // Pass that value to our easing function to get our
    // progress on a curve
    const progress = counterEaseOutQuad(frame / counterTotalFrames);
    // Use the progress value to calculate the current count
    const currentCount = Math.round(countTo * progress);

    // If the current count has changed, update the element
    if (parseInt(el.innerHTML, 10) !== currentCount) {
      const thisElem = el;
      thisElem.innerHTML = currentCount;
    }

    // If we’ve reached our last frame, stop the animation
    if (frame === counterTotalFrames) {
      clearInterval(counter);
    }
  }, counterFrameDuration);
};

// Run the animation on all queried elements
const runAnimations = () => {
  document.querySelectorAll('.counter-block .title').forEach((item) => {
    counterAnimateCountUp(item.lastElementChild);
  });
};

// ##################################################
// 1.0 - Element loop
// ##################################################

const counterElement = document.querySelectorAll('.sc-counter .counter__list');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(({ target, intersectionRatio }) => {
    const hasIntersected = intersectionRatio > 0;
    target.classList.toggle('is-counting', hasIntersected);

    if (hasIntersected) {
      runAnimations();
      observer.unobserve(target); // Stop observing (run only once)
    }
  });
});

counterElement.forEach((counterEl) => {
  observer.observe(counterEl);
});
